import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';
import { RadioButtonsGroup } from '@components/RadioButtonsGroup';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 564,
        '@media (max-width: 600px)': {
            height: 'var(--100vh)',
            width: '100%',
        },
    },
    '& .modal-base-content': {
        padding: '24px 16px',
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridGap: '8px',
    gridTemplateColumns: '100%',
});

export const RadioButtonsWrapper = styled('div')({
    height: 32,
    marginBottom: 16,
    width: 'fit-content',
});

export const RadioButtons = styled(RadioButtonsGroup)({
    display: 'block',
    '& .MuiFormControlLabel-root': {
        height: 32,
        padding: '0 12px',
        flexBasis: 'auto',
    },
});
